import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import config from './config';
import AdvisoryRecommendation from './advisory/AdvisoryRecommendation';
import AdvisoryWebElement from './advisory/AdvisoryWebElement';

const appInsights = new ApplicationInsights(
  {
    config: {
      instrumentationKey: import.meta.env.VITE_INSTRUMENTATION_KEY,
      disableFetchTracking: true,
      disableAjaxTracking: true
    }
  }
);
appInsights.loadAppInsights();
window.applicationInsights = appInsights;

customElements.define(
  config.ADVISORY_RECOMMENDATION_CUSTOM_ELEMENT,
  AdvisoryRecommendation
);

customElements.define(
  config.ADVISORY_CUSTOM_ELEMENT,
  AdvisoryWebElement
);

window.setAdvisoryData = (data: unknown[]) => {
  const advisoryScriptElement = document.createElement('script');
  advisoryScriptElement.setAttribute('type', 'application/json');
  advisoryScriptElement.id = config.ADVISORY_RECEIVED_DATA_SCRIPT_ID;
  advisoryScriptElement.textContent = JSON.stringify(data);
  document.head.appendChild(advisoryScriptElement);
}